"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Experian = void 0;
const loader_1 = require("./loader");
const library_1 = require("../../core/library");
class Experian extends library_1.Library {
    constructor(experianUrl) {
        super('Experian', new loader_1.ExperianLoader(experianUrl));
    }
    initiate(callback) {
        try {
            window.ods.initiate(callback);
        }
        catch (error) {
            throw new Error('Experian not implemented.');
        }
    }
    validate() {
        return window.ods.validate();
    }
}
exports.Experian = Experian;
//# sourceMappingURL=index.js.map